import { Box, Text } from '@mantine/core';
import { Link, useLocation } from 'react-router';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import classes from './AIActionCard.module.css';

import type { DescriptionMode } from '../types';

type Props = {
  label: string;
  description?: string;
  descriptionMode?: DescriptionMode;
  bg?: string;
  href?: string;
  onClick?: () => void;
};

export function AIActionCard({
  label,
  description,
  descriptionMode = 'always_visible',
  bg = 'rgba(0, 0, 0, 0.25)',
  href,
  onClick,
}: Props) {
  const location = useLocation();

  const content = (
    <Box
      className={descriptionMode === 'hover' ? classes.card : undefined}
      px={{ base: 'md', xl: 'xl' }}
      py={{ base: 'xs', xl: 'md' }}
      onClick={href ? undefined : onClick}
      style={{
        background: bg,
        borderRadius: 'var(--mantine-radius-xl)',
        cursor: href || onClick ? 'pointer' : 'default',
      }}
    >
      <Text size="textXl" fw={FONT_WEIGHTS.bold} c="white">
        {label}
      </Text>
      {description && (
        <Text
          className={descriptionMode === 'hover' ? classes.description : undefined}
          size="sm"
          c="rgba(255, 255, 255, 0.7)"
          mt={descriptionMode === 'hover' ? undefined : 'xxxs'}
        >
          {description}
        </Text>
      )}
    </Box>
  );

  if (href) {
    return (
      <Link to={href} state={{ fromPath: location.pathname }} style={{ textDecoration: 'none' }}>
        {content}
      </Link>
    );
  }

  return content;
}
